import { createReducer, on } from '@ngrx/store';
import { ResponseState, initialResponseState } from '../State/responses.state';
import * as ResponseActions from '../Actions/responses.actions';

export const responseReducer = createReducer(
  initialResponseState,

  // Load Responses
  on(ResponseActions.loadResponses, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(ResponseActions.loadResponsesSuccess, (state, { responses }) => {
    return {
      ...state,
      responses: responses,
      filteredResponses: responses,
      isLoading: false,
      error: null,
      lastUpdated: Date.now()
    };
  }),

  on(ResponseActions.loadResponsesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),

  // Load Flow Data
  on(ResponseActions.loadFlowDataSuccess, (state, { responseId, linkedFlows }) => {
    const updatedResponses = state.responses.map(response => 
      response.id === responseId 
        ? { ...response, linkedFlows: linkedFlows }
        : response
    );
    const updatedFilteredResponses = state.filteredResponses.map(response => 
      response.id === responseId 
        ? { ...response, linkedFlows: linkedFlows }
        : response
    );
    return {
      ...state,
      responses: updatedResponses,
      filteredResponses: updatedFilteredResponses
    };
  }),

  // Search and Filter
  on(ResponseActions.setSearchQuery, (state, { query }) => ({
    ...state,
    searchQuery: query
  })),

  on(ResponseActions.filterResponses, (state, { query }) => {
    const filtered = state.responses.filter(response => 
      response.name?.toLowerCase().includes(query.toLowerCase())
    );
    return {
      ...state,
      filteredResponses: filtered,
      searchQuery: query
    };
  }),

  // Add Response
  on(ResponseActions.addResponse, (state) => ({
    ...state,
    isAddingAction: true,
    error: null
  })),

  on(ResponseActions.addResponseSuccess, (state, { response }) => ({
    ...state,
    responses: [...state.responses, response],
    filteredResponses: [...state.filteredResponses, response],
    isAddingAction: false,
    error: null
  })),

  on(ResponseActions.addResponseFailure, (state, { error }) => ({
    ...state,
    isAddingAction: false,
    error: error
  })),

  // Update Response
  on(ResponseActions.updateResponseSuccess, (state, { response }) => ({
    ...state,
    responses: state.responses.map(r => r.id === response.id ? response : r),
    filteredResponses: state.filteredResponses.map(r => r.id === response.id ? response : r),
    selectedResponse: state.selectedResponse && state.selectedResponse.id === response.id ? response : state.selectedResponse
  })),

  // Delete Response
  on(ResponseActions.deleteResponseSuccess, (state, { responseId }) => ({
    ...state,
    responses: state.responses.filter(r => r.id !== responseId),
    filteredResponses: state.filteredResponses.filter(r => r.id !== responseId)
  })),

  // Clear Responses
  on(ResponseActions.clearResponses, (state) => ({
    ...state,
    responses: [],
    filteredResponses: [],
    searchQuery: '',
    error: null
  })),

  // Set Loading States
  on(ResponseActions.setLoading, (state, { isLoading }) => ({
    ...state,
    isLoading: isLoading
  })),

  on(ResponseActions.setAddingAction, (state, { isAddingAction }) => ({
    ...state,
    isAddingAction: isAddingAction
  })),

  // Selected Response
  on(ResponseActions.setSelectedResponse, (state, { response }) => {
    let disable = false;

    if (response?.payload?.quick_replies?.length > 0) {
      disable = true;
    }

    return {
      ...state,
      selectedResponse: response,
      disableAddMessage: disable,
    };
  }),

  on(ResponseActions.clearSelectedResponse, (state) => ({
    ...state,
    selectedResponse: null,
  })),

  // Selected Child
  on(ResponseActions.setSelectedChild, (state, { child }) => ({
    ...state,
    selectedChild: child,
  })),

  on(ResponseActions.clearSelectedChild, (state) => ({
    ...state,
    selectedChild: null,
  })),
);